import { Text } from '../../components/typography';
import styles from './OpenClosedMenu.module.scss';
export default function OpenClosedMenu({
  selected,
  setSelected,
  options = ['Open', 'Closed'],
  size = 'sm',
}) {
  return (
    <div className={styles.flexRow}>
      {options?.map((o) => (
        <div className={styles.flexRow}>
          <Text
            noMargin
            className={selected === o ? styles.borderBlue : ''}
            hover
            color={selected === o ? 'accentPrimary' : 'secondary'}
            weight={selected === o ? 'bold' : 'regular'}
            size={size}
            onClick={() => {
              setSelected(o);
            }}
          >
            {o}
          </Text>
        </div>
      ))}
    </div>
  );
}
